module.exports = __webpack_public_path__ + "static/media/image-2.03b04fd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/TextEditor/image-2.png
// module id = 271
// module chunks = 0